/**
 * "Your results are shared" — what an acceptance hands the TestIt page when
 * the TestIt ask it accepted was already complete. (D3 · 4 Oct 2026)
 *
 * Every asked test was banked before the invitation existed, so accepting it
 * left nothing to take: the citizen landed on a TestIt page that showed
 * nothing, and was told nothing. The acceptance's own answer says so now, and
 * rides the navigation as history state — it is the fact of THIS acceptance
 * (this company, these tests), which no later read of the page can rebuild
 * once a second company asks for something else on the same journey.
 */
import type { AcceptAskedTest } from '@tonnie/sdk';

export interface TestitSharedConfirmation {
  company: string;
  tests: AcceptAskedTest[];
}

/** The history-state entry the TestIt page looks for. */
const STATE_KEY = 'testitShared';

export function testitSharedState(confirmation: TestitSharedConfirmation): Record<string, unknown> {
  return { [STATE_KEY]: confirmation };
}

/** The confirmation a navigation carried, or `null` — anything else in the state is not one. */
export function readTestitShared(state: unknown): TestitSharedConfirmation | null {
  if (typeof state !== 'object' || state === null) return null;
  const value = (state as Record<string, unknown>)[STATE_KEY];
  if (typeof value !== 'object' || value === null) return null;
  const { company, tests } = value as { company?: unknown; tests?: unknown };
  if (typeof company !== 'string' || !Array.isArray(tests)) return null;
  return { company, tests: tests as AcceptAskedTest[] };
}
